module.exports = __webpack_public_path__ + "img/ph_qrcode_viber.971a537.webp";